<template>
  <div
    class="invoice__status"
    :class="[
      { 'invoice__status--success': successBackground },
      { 'invoice__status--warning': warningBackground }
    ]"
  >
    <span v-if="status === 'PAID_OUT'">
      {{ $t(`${namespace}.paidOutInvoice`) }}
    </span>

    <span v-else-if="status === 'INVOICE_SENT'">
      {{ $t(`${namespace}.closedInvoice`) }}
    </span>

    <span v-else-if="status === 'AUTHORISED'">
      {{ $t(`${namespace}.closedInvoice`) }}
    </span>

    <span v-else-if="status === 'REFUSED'">
      {{ $t(`${namespace}.lateInvoice`) }}
    </span>

    <span v-else-if="status === 'LATE'">
      {{ $t(`${namespace}.lateInvoice`) }}
    </span>

    <span v-else-if="status === 'CURRENT'">
      {{ $t(`${namespace}.currentInvoice`) }}
    </span>

    <span v-else-if="status === 'EXTEND'">
      {{ $t(`${namespace}.closedInvoiceExtendMaturity`) }}
    </span>

    <span v-else>
      {{ $t(`${namespace}.withoutStatus`) }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'InvoiceStatus',
  props: {
    status: {
      type: String
    }
  },
  computed: {
    successBackground () {
      return this.status === 'PAID_OUT' ||
        this.status === 'INVOICE_SENT' ||
        this.status === 'AUTHORISED' ||
        this.status === 'CURRENT' ||
        this.status === 'EXTEND'
    },

    warningBackground () {
      return this.status === 'REFUSED' || this.status === 'LATE'
    }
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.financial.status'
    }
  }
}
</script>

<style lang="scss">
.invoice__status {
  background-color: $gray-3;
  font-size: $base-font-size - 1px;
  font-weight: 600;
  line-height: normal;
  padding: 9px 0;
  text-align: center;
  text-transform: uppercase;
}

.invoice__status--success {
  background-color: $success;
  color: $white;
}

.invoice__status--warning {
  background-color: $accent-2;
  background-image: linear-gradient(95deg, $primary, $accent-2);
  color: $white;
}

.invoice__status--danger {
  background-color: $error;
  background-image: linear-gradient(95deg, $error, darken($error, 15));
  color: $white;
}
</style>
